import React, { FC, ReactNode } from "react";
import cn from "classnames";
import "./LineChartTooltip.styles.scss";
import {
    iTooltipRow,
    iTooltipColumnsGroup,
} from "./LineChartTooltip.helpers";

const LineChartTooltip: FC<{
    title: ReactNode;
    rows: iTooltipRow[];
    data: iTooltipColumnsGroup[];
    x: number;
    y: number;
    position: 'left' | 'right';
}> = ({
    title,
    data,
    rows,
    x,
    y,
    position,
}) => {
    return (
        <div
            className="LineChartTooltip__container"
            style={{
                transform: `translate(${x}px, ${y}px)`,
            }}
        >
            <div className={cn("LineChartTooltip", `LineChartTooltip--${position}`)}>
                <div className="LineChartTooltip__table">
                    <div className="LineChartTooltip__group LineChartTooltip__group--fluid">
                        <div className="LineChartTooltip__head" style={{ zIndex: 2 }}>
                            <div className="LineChartTooltip__cell LineChartTooltip__cell--head">
                                {title}
                            </div>
                        </div>
                        <div className="LineChartTooltip__body">
                            {rows.map((row) => (
                                <div key={row.color} className="LineChartTooltip__row">
                                    <div className="LineChartTooltip__cell LineChartTooltip__cell--fluid">
                                        <div className="LineChartTooltip__colors">
                                            <div className="TooltipPoint" style={{ color: row.color }}/>
                                        </div>
                                        <div className="LineChartTooltip__name">{(row.title || '').toUpperCase()}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {data.length > 1 && (
                            <div className="LineChartTooltip__footer">
                                <div className="LineChartTooltip__footer-label"/>
                            </div>
                        )}
                    </div>

                    {data.map((group, groupIndex) => (
                        <div key={group.title} className={cn([
                            "LineChartTooltip__group",
                            groupIndex % 2 === 1 && "LineChartTooltip__group--muted",
                        ])}>
                            <div className="LineChartTooltip__head">
                                {group.columns.map((column) => (
                                    <div
                                        key={column.index}
                                        className="LineChartTooltip__cell"
                                    >
                                        {column.title}
                                    </div>
                                ))}
                            </div>

                            <div className="LineChartTooltip__body">
                                {rows.map((row, rowIndex) => (
                                    <div key={`${row.title}-${rowIndex}`} className="LineChartTooltip__row">
                                        {group.columns.map((column) => (
                                            <div key={column.index} className="LineChartTooltip__cell">
                                                {row.values[column.index]}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>

                            {data.length > 1 && (
                                <div className="LineChartTooltip__footer">
                                    <div className={cn([
                                        "LineChartTooltip__footer-label",
                                        groupIndex % 2 === 1 && "is-muted",
                                    ])}>
                                        {group.title}
                                    </div>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LineChartTooltip;
